import React, { FC } from 'react';
import { View, Interactable, Icon } from '@24i/nxg-sdk-quarks';
import { getFont, useTheme } from '@24i/nxg-sdk-higgs';
import { DeviceInfo } from '@24i/nxg-sdk-quantum';
import { Animated } from 'react-native';
import { getStyles } from './styles';

type Props = {
    onClose: () => void;
    height: number;
    show?: boolean;
    variant?: 'centered';
};

export const ExpandedPlayerContainer: FC<Props> = ({
    show,
    onClose,
    children,
    height,
    variant,
}) => {
    const { theme } = useTheme();
    const styles = getStyles(theme, height ?? 0, DeviceInfo.isTablet());

    // FIXME: use real icon for closing functionality (when available in BS)
    const closeIcon = theme.icons['onPrimary-close'];

    return (
        <Animated.View
            style={[
                styles.container,
                variant === 'centered' && styles.centeredContainer,
                {
                    transform: [
                        {
                            translateY: show ? 0 : height,
                        },
                    ],
                },
            ]}
            pointerEvents={show ? 'auto' : 'none'}
        >
            <View style={styles.closeButton}>
                <Interactable onPress={onClose}>
                    <Icon
                        size={getFont(theme, 'h2').fontSize}
                        name={closeIcon.iconName}
                        font={closeIcon.iconFont}
                        color={theme.color.textPrimary}
                    />
                </Interactable>
            </View>

            <View style={styles.inner}>{children}</View>
        </Animated.View>
    );
};
